import React from 'react';

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 10.5L8.5 14L15 7" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CheckIcon;
